import { IMAGE_TYPE } from "./../ricos-content/index.js";
import { unreachable } from "./../ricos-content/ts-utils.js";
import { logInvariant } from "./../_shared/log-invariant.js";
import { upload } from "./../_shared/upload/upload.js";
import { RICOS_DEFAULTS } from "./consts.js";
const getImagePickMedia = ({
  services,
  config
}) => {
  const { handleFileUpload, handleFileSelection } = config;
  const devPickMedia = services.devService().pickMedia;
  const pickMedia = devPickMedia ? devPickMedia : handleFileSelection ? async ({ multiple }) => {
    const data = await new Promise(
      (resolve) => handleFileSelection(
        void 0,
        multiple,
        ({ data: data2 }) => resolve(data2),
        void 0,
        RICOS_DEFAULTS
      )
    );
    return { type: "ready-media", media: data };
  } : async ({ mimeType, multiple }) => {
    const files = await services.uploadService?.selectFiles({ accept: mimeType, multiple }) ?? [];
    return { type: "file", file: files, customUploadFn: handleFileUpload };
  };
  return pickMedia;
};
const handleImageUpload = async ({
  services,
  config,
  publicCommands,
  nodeId,
  files,
  pos
}) => {
  const { accept = "image/*", multi = true, handleFileUpload } = config;
  const multiple = nodeId ? false : multi;
  const pickMedia = getImagePickMedia({ services, config });
  const result = files ? {
    type: "file",
    file: files,
    customUploadFn: handleFileUpload
  } : await pickMedia({ mimeType: accept, multiple });
  switch (result.type) {
    case "ready-media": {
      if (nodeId) {
        const componentData = publicCommands?.getBlockComponentData(nodeId);
        const { file_name, width, height } = result.media[0] || {};
        publicCommands?.setBlock(nodeId, IMAGE_TYPE, {
          ...componentData,
          image: { src: { id: file_name }, width, height },
          tempData: null,
          loading: null,
          error: null
        });
        return;
      }
      result.media.forEach((item, index) => {
        setTimeout(() => {
          const { file_name, width, height } = item;
          publicCommands.insertBlockWithBlankLines(
            IMAGE_TYPE,
            { image: { src: { id: file_name }, width, height }, ...RICOS_DEFAULTS },
            {
              updateSelection: result.media.length === index + 1
            }
          );
        });
      });
      return;
    }
    case "file": {
      const resultFiles = result.file;
      const insertOptions = files ? { skipBlankLineBefore: true, skipBlankLineAfter: true } : {};
      return resultFiles.map(async (file, index) => {
        setTimeout(async () => {
          const targetNodeId = nodeId ?? publicCommands.insertBlockWithBlankLines(IMAGE_TYPE, RICOS_DEFAULTS, {
            updateSelection: resultFiles.length === index + 1,
            ...insertOptions,
            pos
          });
          const trackBi = services.uploadService.trackUploadBi(IMAGE_TYPE, file.size, file.name);
          try {
            const url = URL.createObjectURL(file);
            await Promise.resolve();
            publicCommands?.setBlock(targetNodeId, IMAGE_TYPE, {
              ...publicCommands?.getBlockComponentData(targetNodeId),
              image: void 0,
              tempData: url,
              loading: true,
              error: null
            });
            trackBi?.start();
            const uploadFn = result.customUploadFn || handleFileUpload;
            if (!uploadFn) {
              logInvariant(Error("No upload function provided"));
              throw new Error("No upload function provided");
            }
            const uploadedFile = await upload(uploadFn, file);
            const { file_name, width, height } = uploadedFile.data || {};
            publicCommands?.setBlock(targetNodeId, IMAGE_TYPE, {
              ...publicCommands?.getBlockComponentData(targetNodeId),
              image: { src: { id: file_name }, width, height },
              tempData: null,
              loading: null,
              error: null
            });
            URL.revokeObjectURL(url);
            trackBi?.success();
            return;
          } catch (error) {
            const componentData = publicCommands?.getBlockComponentData(targetNodeId);
            publicCommands?.setBlock(targetNodeId, IMAGE_TYPE, {
              ...componentData,
              error,
              loading: null
            });
            trackBi?.error(error);
            services.uploadService.notifyError(error);
            return;
          }
        });
      });
    }
    case "cancel": {
      return;
    }
    default: {
      console.error(unreachable(result));
      return;
    }
  }
};
export {
  handleImageUpload
};
//# sourceMappingURL=handle-image-upload.js.map
